import { getHMSDisplay } from "@/helpers/time";

export default {
  filters: {
    prettyTime(t) {
      return getHMSDisplay(t);
    },
  },
};
